module.exports = __webpack_public_path__ + "res/ic_menu_campaigns_st.87593ad10e7f0b0cf0150e403c52d530.png";